import { initDataLayer, isBrowser, persistTrackingData } from '../util';
export function pushHotelBasketSummary({ hotelAvailability }) {
    var _a, _b, _c;
    if (!isBrowser())
        return;
    initDataLayer();
    const selectedHotel = {
        availability: {
            price: hotelAvailability === null || hotelAvailability === void 0 ? void 0 : hotelAvailability.pricingSummary.price,
            promotion: (_c = (_b = (_a = hotelAvailability === null || hotelAvailability === void 0 ? void 0 : hotelAvailability.pricingSummary) === null || _a === void 0 ? void 0 : _a.callout) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.join(' '),
            rooms: hotelAvailability === null || hotelAvailability === void 0 ? void 0 : hotelAvailability.requestedRooms.map((room) => room.availability.map(({ masterRoom: { id, title }, boardOptions }) => ({
                id,
                title,
                boardOptions: boardOptions === null || boardOptions === void 0 ? void 0 : boardOptions.map((option) => ({
                    description: option.pricingSummary.boardTypeDescription,
                    price: option.pricingSummary.price,
                    id: option.boardOptionId,
                })),
            }))),
        },
    };
    window.dataLayer.push({
        event: 'hotelAvailabilityLoaded',
        selectedHotel,
    });
    persistTrackingData({ selectedHotel }, true);
}
